const LabeledValue = (props) => {
  const { label, value } = props

  return (
    <div className="px-2 flex flex-col gap-1">
      <p className="font-medium text-primary">{label}</p>
      <p className="ml-0.5 text-[16px]">{value || "N/A"}</p>
    </div>
  )
}

export default LabeledValue
